import type { ReactNode } from "react";

interface Props {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
  height?: "70" | "80";
}

export const Sheet = ({ open, title, onClose, children, height = "80" }: Props): JSX.Element | null => {
  if (!open) return null;

  return (
    <>
      <button className="sheet-backdrop" aria-label="Close sheet" onClick={onClose} />
      <div className="sheet" style={{ maxHeight: `${height}dvh` }}>
        <div className="mx-auto mb-3 h-1 w-8 rounded-full bg-[var(--border-default)]" />
        <div className="mb-3 flex items-center justify-between">
          <h2 className="text-lg font-semibold">{title}</h2>
          <button type="button" className="btn btn-ghost !min-h-0 !p-0 text-sm" onClick={onClose}>
            Close
          </button>
        </div>
        {children}
      </div>
    </>
  );
};
